var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"overflow-auto"},_vm._l((_vm.items),function(item,index){return _c('li',{key:item.id,staticClass:"cursor-pointer",class:{
      'border-dashed': index != _vm.hideBorderIndex,
      'border-b': index != _vm.hideBorderIndex,
    },on:{"click":function($event){return _vm.selectLine(item.component)}}},[_c('div',{staticClass:"flex items-center justify-between py-3"},[_c('span',{staticClass:"text-base base-font-gray-200",class:{
          'font-sansDemi': _vm.activeLine == item.component,
          'active-item': _vm.activeLine == item.component,
        }},[_vm._v(" "+_vm._s(item.title)+" ")])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }